import type { ColumnContent } from '../../../domain/ColumnContent'
import type { ColumnContentDTO } from '../../../domain/ColumnContentDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'
import type { PartnerId } from '../../../../../types/PartnerId'
import type { SkinVariant } from '../../../../../types/SkinVariant'

import { isAvailablePartner } from '../../../../../utils/filter-by-partner'
import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'
import { mapEntryDTOList } from '../../../../../utils/map-entry-dto-list'

export const mapColumnContentFromApi = (dto: ColumnContentDTO, partnerId?: PartnerId): ColumnContent | undefined => {
  if (!(isNonNullableEntryDTO(dto) && isAvailablePartner(partnerId, dto.fields.partnerFilter))) {
    return undefined
  }

  const { anchorLabel, blocs, description, breakpoint, backgroundColor, title, variant } = dto.fields

  const blocks = mapEntryDTOList<any>(blocs) || []

  return {
    anchorLabel,
    blocs: blocks,
    breakpoint,
    contentType: ContentModelId.COLUMN_CONTENT,
    description,
    skinVariant: backgroundColor?.replace('-color', '') as SkinVariant,
    title,
    variant,
  }
}
